function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 10"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M24 0v24H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 3h-7a1 1 0 000 2h4.586L13 11.586 9.707 8.293a1 1 0 00-1.414 0L3 13.586V3a1 1 0 00-2 0v19a1 1 0 001 1h19a1 1 0 000-2H3v-4.586l6-6 3.293 3.293a1 1 0 001.414 0L21 6.414V11a1 1 0 002 0V4a1 1 0 00-1-1z"
})));